module.exports = function(successCallback, errorCallback) {
	require.ensure([], function() {
		successCallback(require("!!../../../../node_modules/babel-loader/lib/index.js!./PaypalSelfHostedPage.js"));
	}, function() {
		if (errorCallback) errorCallback.apply(this, arguments);
	});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/split-chunk-loader?lazy!./src/Checkout/ShippingAndPayment/Paypal/PaypalSelfHostedPage.js
// module id = 1175
// module chunks = 58